<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { inject, ref, computed, toValue } from "vue";
import { Primitive } from "@maas/vue-primitive";
import { onKeyStroke } from "@vueuse/core";
import { useAccordionTrigger } from "../composables/private/useAccordionTrigger";
import { MagicAccordionInstanceId, MagicAccordionViewId } from "../symbols";
import { useAccordionState } from "../composables/private/useAccordionState";
import { useAccordionView } from "../composables/private/useAccordionView";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicAccordionTrigger",
  props: {
    disabled: { type: null, required: false, default: false },
    trigger: { type: String, required: false, default: "click" },
    asChild: { type: Boolean, required: false, default: false }
  },
  setup(__props) {
    const elRef = ref(void 0);
    const instanceId = inject(MagicAccordionInstanceId, void 0);
    const viewId = inject(MagicAccordionViewId, void 0);
    if (!instanceId) {
      throw new Error(
        "MagicAccordionTrigger must be nested inside MagicAccordionProvider"
      );
    }
    if (!viewId) {
      throw new Error(
        "MagicAccordionTrigger must be nested inside MagicAccordionView"
      );
    }
    const { initializeState } = useAccordionState(instanceId);
    const state = initializeState();
    const { getView } = useAccordionView(instanceId);
    const view = getView(viewId);
    const mappedDisabled = computed(
      () => toValue(__props.disabled) || state.options.disabled
    );
    const { onMouseenter, onClick, onEnter } = useAccordionTrigger({
      instanceId,
      viewId,
      elRef,
      disabled: __props.disabled,
      trigger: __props.trigger
    });
    onKeyStroke("Enter", onEnter);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Primitive), {
        ref_key: "elRef",
        ref: elRef,
        "as-child": _ctx.asChild,
        "data-disabled": mappedDisabled.value,
        class: "magic-accordion-trigger",
        as: "button",
        onMouseenter: _unref(onMouseenter),
        onClick: _unref(onClick)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {
            viewActive: _unref(view)?.active
          })
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["as-child", "data-disabled", "onMouseenter", "onClick"]);
    };
  }
});
</script>

<style>
.magic-accordion-trigger[data-disabled='true'] {
  cursor: var(--magic-accordion-trigger-cursor-disabled, not-allowed);
}
</style>
